import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const Pizzeria = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/outlet/pizzeria/billing.webp",
            tag: "Point Of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Efficient Billing System",
            desc:" This Pizzeria POS System will save time in your checkout operation. Time can be taken to accomplish your checkout operation fast and accurately with every pass. This saves your staff time in handling orders, making out bills, or presenting receipts—all within a click.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    The billing process is made speedier thereby cutting long queues.
                </>,
                <>
                    It accepts various payment options like cards, UPI, cash, wallet, loyalty points etc  for customer’s convenience.
                </>,
                <>Cut down on errors and ensure perfect billing with our intuitive software.</>,
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/pizzeria/inventory.webp",
            tag: "Inventory Management",
            icon: "/assets/outlet/iceCreamOutlet/inventoryManagementIcon.svg",
            title: "Inventory & Raw Material Tracking",
            desc: "Running a pizzeria involves working with multiple ingredients, from dough and sauce to toppings and seasonings. The Inventory & Raw Materials Tracking feature helps keep track of your inventory in real-time for optimum stock levels. ",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    View your actual stock levels and receive alerts for low stock levels.
                </>,
                <>
                    Waste minimized and maximum cost control over ingredients.
                </>,
                <>
                    Automate all reordering activities to ensure that the business never runs out of its essentials.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/outlet/pizzeria/kot.webp",
            tag: "KOT Management",
            icon: "/assets/outlet/iceCreamOutlet/kot_management.svg",
            title: "Precise Kitchen Order Management for Faster Service",
            desc:  [
                    <>Our KOT management feature allows orders to be routed precisely and quickly to your kitchen staff. It will automatically route them to the appropriate kitchen stations in real-time, reducing confusion and errors in your kitchen. Better follow through on faster cooking times, consistent food quality, and making sure your customers leave happy with their exact order.</>,
            ],
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>
                    Accurate order routing Ensure orders are sent to the appropriate kitchen stations for timely preparation.
                </>,
                <>
                    Fewer errors at the kitchen end because of clear, detailed order tickets.
                </>,
                <>
                    Makes orders of food faster by delivering the order.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/outlet/pizzeria/online-order.webp",
            tag: "Swiggy, Zomato Integration",
            icon: "/assets/outlet/iceCreamOutlet/integration_pos.svg",
            title: "Online Ordering Management",
            desc: "With online ordering now being the need of the hour for a successful pizzeria, its management must synchronize with your POS system: the processing and placement of online orders, towering success, and acceptance of in-house ones. Any order that comes, be it through the restaurant's website or any of the third-party platforms, gets directly sent into your kitchen, leaving no possibility for it to get lost.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Manage online and in-house orders from one place.
                </>,
                <>
                    Keep the customers updated on their orders at all times.
                </>,
                <>
                    Tap into the humongous food ordering demand online and increase your sales.
                </>,
            ],
        },
        {
            id: 5,
            image: "/assets/outlet/pizzeria/discount.webp",
            tag: "CRM & Loyalty",
            icon: "/assets/outlet/iceCreamOutlet/CRM.svg",
            title: "Discounts and Loyalty Programs",
            desc: "Our POS includes an integrated Discounts and Loyalty Programs module that will allow you to set up any kind of promotions and customized reward schemes for your customers so they return. Give out discounts, collect points for bonuses, give custom discounts—send these offers directly to your customers, all this via POS. ",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF3F3",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Define and easily execute customer discounts, special offers, and loyalty programs.
                </>,
                <>
                    Send them personalized offers to win back and stay loyal.
                </>,
                <>
                    Drive sales with the power of rewarding your most loyal shoppers.
                </>,
            ],
        },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What distinguishes QueueBuster Pizzeria POS System from other restaurant POS systems available in the market?
                </span>
            ),
            des: "The QueueBuster Pizzeria POS System is tailored concerning the needs that set up quick-service restaurants serving pizzas. While most POS systems are generic, our product integrates features designed explicitly for pizzeria operations: inventory and raw material tracking of ingredients, KOT management for ordered organization of kitchen operations, and online ordering management that sorts in-house orders from digital orders effortlessly. Furthermore, our system comes with robust billing software that involves integrated multi-payment options with a fully customizable discount and loyalty program. All of this within one system not only increases efficiency but also enhances customer satisfaction through the delivery of quicker and more reliable service tailored to meet the unique challenges of running a pizzeria.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the billing software in QueueBuster Pizzeria POS System facilitate a decrease in checkout times?
                </span>
            ),
            des: "This billing software of the QueueBuster Pizzeria POS System facilitates fast checkout for customers, cutting down on their waiting time to near zero in a queue. It has an easy-to-use interface that will help your staff members quickly get through orders, issue receipts, and process payments with only a few clicks of the mouse. This system is really versatile; it supports various payment modes, including cash, credit/debit cards, and digital wallets—all ensuring that customers can pay by whichever means they prefer most without delay. As a matter of fact, this facilitates the aspect of fastness and things getting done within the restaurant as it teaches the staff how to cope with peak hours and brings high turnover and increased revenue.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the inventory and raw material tracking feature assist in the management of pizzeria supplies?
                </span>
            ),
            des: "Inventory and raw material tracking is a very strong feature that pizzeria owners use with the QueueBuster Pizzeria POS System to maintain optimal stock levels of main ingredients like dough, sauce, cheese, and toppings. It makes provision for real-time insight into the level of your inventory and even automates alerts so that action can be taken in advance against any run-out situations that may turn into aggrievances. Moreover, the developed system supports the generation of detailed reports to know the usage pattern of the consumed formulations, ingredients, and time of activity. This provides information for even better inventory management to avoid overstocking and understocking, thus minimizing losses or wastage, therefore reducing costs in inventory maintenance and efficient operation.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is KOT management, and what is its benefit to the kitchen staff?
                </span>
            ),
            des: "KOT Management stands for Kitchen Order Ticket Management. It is one of the standout features integrated into the QueueBuster Pizzeria POS System, from which all orders are automatically and instantly routed to the kitchen staff with maximum efficiency. Right from the moment an order is placed, they go through to the correct kitchen station for cooking, minimizing confusion and errors. In this regard, the system would ensure shorter preps, unvarying food quality, and smooth working of the kitchen. For example, the KOT Management system is designed to enhance communication between the front-of-house and kitchen staff such that a customer receives exactly what he/she has ordered—hence increased customer satisfaction and more repeat business.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the Online Ordering Management feature integrate with POS?
                </span>
            ),
            des: "The Online Ordering Management facility of QueueBuster Pizzeria POS is seamlessly integrated with your POS operations to help manage online orders with in-house orders from the same place. These orders, whether placed through your pizzeria's website or any other delivery aggregator, get synchronized with your POS system and automatically communicate to the kitchen. This way, all orders are attended to immediately and correctly, without any possibility of getting lost or overlooked. Real-time order status is also offered to customers, which further facilitates communication and makes the whole process of dealing with customers much improved. The features work by incorporating online ordering with already preexisting operations to help the food delivery and takeout corner grow, increasing cells, and consequently developing a clientele base.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is the Discounts and Loyalty Programs module customizable to support specific promotional strategies?
                </span>
            ),
            des: "Yes, using this module in the QueueBuster Pizzeria POS system, you will be able to render a host of promotions and rewards that will be very suitable for your customer base. So, in the context of running seasonal discounts, creating a points-based loyalty program, or sending personalized offers to certain customers, the module renders the capability for designing and executing such campaigns. You can set up and easily monitor multiple promotions, give rewards based on your customers' behavior automatically, and target your customer base with personalized deals, bringing much-needed value to those very important customer segments. This flexibility allows you to increase customer interaction, drive repeat business, and foster a loyal customer base that is always returning.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the system accommodate multiple options of payment available during the billing process?
                </span>
            ),
            des: "The billing software was supported by many payments that a customer would like to make using the QueueBuster Pizzeria POS system, erasing any barriers to the way a customer would like to pay. The system does accept traditional ways of payment, including cash and the use of credit/debit cards, with support for digital wallet payment and other new kinds of technologies in payment. The software allows employees to change forms of payment and split payments with just a few clicks. They can issue receipts themselves without incurring added costs. Such flexibility assists in clients having easy lives while trying to make choices of payments. It speeds up the transaction times, thus keeping the checkout process at optimal and at ease, even during peak hours.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How robust is the QueueBuster Pizzeria POS System, especially in terms of handling online orders and payments?
                </span>
            ),
            des: "Security, of course, is the most considered feature of the QueueBuster Pizzeria POS system, especially with the handling of very sensitive customer details in online orders and payments. The system provides advanced encryption protocols in the transactions that bring an assurance in data safety through transactions and protect customer payment details.Moreover, the system follows security industry standards and extends further to include compliance for securing fraud and data breaches. It also ensures regular updating of software and security patches, among other measures, so that no stone is left unturned in ensuring a POS system that is safe and dependable for you.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can the QueueBuster Pizzeria POS System be multi-locational or run as a franchise system?
                </span>
            ),
            des: "Indeed, the QueueBuster Pizzeria POS System is scalable and stands to be the best suited for pizzerias operating under multiple locations or franchises. It makes it possible to manage operations across different outlets from one point of operation to enable total real-time visibility into sales, inventory, and customer data at whichever store. You will standardize processes and promotions throughout all your restaurants easily and manage performance measures for the resolution of weaknesses by using a consistent and efficient application. Besides, it provides one the ability to compare data from various sites in coming up with multi-location reports and analyses to facilitate informed business decisions. One pizzeria or many; it does not matter. Either way, the QueueBuster POS System remains ready to help you run a successful business.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the QueueBuster POS System provide backup and training support?
                </span>
            ),
            des: "At QueueBuster, we believe in providing total help and training in regard so that you, along with your staff, can use the Pizzeria POS System. We provide first-few-days configuration, ensuring that the system is set up according to your specific needs. We also offer training for you to administer the system to your staff, from general operation to inventory management and even setting privileges on the system for your loyal members. Moreover, QueueBuster offers phone, email, and live chat support for questions or any technical problems that you may have. Our dedicated support team is available around the clock to ensure that your POS system runs smoothly, allowing you to focus on delivering great service to your customers.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/pizzeria/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span>POS Billing Software for</span><span></span>
                                <span>&nbsp; Pizzeria</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Welcome to the ultimate Pizzeria POS Billing System, made only for your pizza outlet/restaurant. This is QueueBuster's advanced POS solution, which masters every part of your pizzeria, from billing and order management to inventory control, online orders, and customer loyalty programs—all seamlessly integrated.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/outlet/pizzeria/hero-img.webp"
                            heading={<>POS Billing Software for</>}
                            staticHeading={<>Pizzeria</>}
                            description={"Welcome to the ultimate Pizzeria POS Billing System, made only for your pizza outlet/restaurant. This is QueueBuster's advanced POS solution, which masters every part of your pizzeria, from billing and order management to inventory control, online orders, and customer loyalty programs—all seamlessly integrated."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "55%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>The Ultimate Pizzeraia POS System Features</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"QueueBuster Pizzeria POS System - Frequently Asked Questions"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"QueueBuster Pizzeria POS System - Frequently Asked Questions"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default Pizzeria